var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',_vm._b({attrs:{"options":_vm.options},model:{value:(_vm.local_value),callback:function ($$v) {_vm.local_value=$$v},expression:"local_value"}},'b-form-select',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }